import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext'; // ✅ Import useAuth
import { API_URL, MAC_ADDR_URL } from './environment';
import { collectLoginClientInfo } from "../helpers/browser-info";

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [continueLoginMode, setContinueLoginMode] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth(); // ✅ Get login function and user from AuthContext
  const [bettingShop, setBettingShop] = useState('');
  const [bettingShopsDD, setBettingShopsDD] = useState([]);


  useEffect(() => {
    document.body.classList.add('validate-active');
    
    // ✅ Check if user is already logged in and redirect to dashboard
    if (user && !continueLoginMode) {
      navigate('/dashboard');
    }
    
    return () => {
      document.body.classList.remove('validate-active');
    };
  }, [user, navigate]);

  // Hypothetical function to get client MAC (only works in specific environments)
  const getClientMAC = async() => {
    // Example fallback: a function or library call that returns the MAC address.
    // This might be unavailable in normal browsers for security reasons.
    return "00-11-22-33-44-55";
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle the 'Continue' button press logic
    if (continueLoginMode) {
      localStorage.setItem('sun_bettingShopId', bettingShop);
      // ! TODO: resave logged in cashier
      // login({
      //   role: userRole,
      //   userId: userData.userId,
      //   bettingShops: bettingShopsData,
      //   bettingShopId: userData?.bettingShops?.[0]?._id
      // });
      navigate('/dashboard');
      return;
    }

    try {
      // handle mac address send
      // const macApiRes = await axios.get(MAC_ADDR_URL);
      // const curMac = (ipRes && ipRes.data && ipRes.data.ip) || 0;
      // console.log('curMac', curMac);

      // GET ip address
      const IP_SERVICE = 'https://api64.ipify.org/?format=json';
      const ipRes = await axios.get(IP_SERVICE);
      // console.log('ipRes', ipRes);
      const curIp = (ipRes && ipRes.data && ipRes.data.ip) || 0;

      const response = await axios.post(`${API_URL}/login`, {
        username: username,
        password: password,
        ip: curIp,
      });

      const userData = response && response.data;
      const isLoggedIn = userData && userData.success === true;

      if (isLoggedIn) {

        const bettingShopsData = userData?.bettingShops || [];
        setBettingShopsDD(bettingShopsData);

        const userRole = userData.role || "CASHIER"; // Default role if not provided
        // save betting shop id to local storage, if a user has restrictions

        // save related betting shops "," separated string
        const currentBettingShopsIds = bettingShopsData.map(o => o._id).join(',');
        if (bettingShopsData.length) {
          localStorage.setItem('sun_bettingShopsList', currentBettingShopsIds);
        }

        if (userData.userId) {
          localStorage.setItem('sun_userId', userData.userId);
        }

        localStorage.setItem('sun_userRole', userRole);

        const loggedShopId = userData?.bettingShops?.[0]?._id || '';

        const metadata = await collectLoginClientInfo({
          includeGeolocation: true,
          geolocationOptions: {
            enableHighAccuracy: false,
            timeout: 2000,
            maximumAge: 300000,
          },
        });

        try {
          await axios.post(`${API_URL}/logaction`, {
            action: 'login_user',
            role: userRole,
            user: userData.userId,
            bettingShopId: loggedShopId,
            metadata,
            ipAddress: curIp,
          });
        } catch (e) {
          console.log(e);
        }

        if (userRole !== "CASHIER" || userData?.bettingShops?.length === 1) {
          const shopId = userData?.bettingShops?.[0]?._id || '';
          if (userData.bettingShops) {
            localStorage.setItem('sun_bettingShopId', shopId);
          }
          // ✅ Call `login()` with complete user data for session persistence
          login({
            role: userRole,
            userId: userData.userId,
            bettingShops: bettingShopsData,
            bettingShopId: userData?.bettingShops?.[0]?._id
          });

          navigate('/dashboard');
          return;
        } else if (userRole === "CASHIER" && userData?.bettingShops?.length > 1) {
          // if it's cashier, we should check if he has active shifts in one of betting shops
          const cashierId = localStorage.getItem('sun_userId');
          // const bettingShopId = bettingShop;
          // get betting shop where we have
          const checkShiftRes = await axios.post(`${API_URL}/checkcashiershifts`, {
            agentId: cashierId,
          });

          const hasActiveShift = checkShiftRes?.data?.hasActiveShift;
          const activeShiftShopId = checkShiftRes?.data?.activeShiftShopId;
          if (hasActiveShift) {
            localStorage.setItem('sun_bettingShopId', activeShiftShopId);

            // ✅ Call `login()` with complete user data for session persistence
            login({
              role: userRole,
              userId: userData.userId,
              bettingShops: bettingShopsData,
              bettingShopId: userData?.bettingShops?.[0]?._id
            });
            navigate('/dashboard');
          }
          setContinueLoginMode(true);
          // ✅ Call `login()` with complete user data for session persistence
          login({
            role: userRole,
            userId: userData.userId,
            bettingShops: bettingShopsData,
            bettingShopId: userData?.bettingShops?.[0]?._id
          });
        }
        return;
      } else {
        alert('Invalid credentials');
      }
    } catch (error) {
      console.error("Login failed:", error);
      alert("An error occurred. Please try again.");
    }
  };

  // Handle changes to the inputs
  const handleBetShopChange = (event) => {
    const { name, value } = event.target;
    setBettingShop(value);
  };
  

  return (
    <form onSubmit={handleSubmit} className="auth-user" autoComplete="off">
      {/* 🛑 Hidden dummy fields to trick autofill */}
      <input type="text" name="fake_username" autoComplete="username" style={{ display: "none" }} />
      <input type="password" name="fake_password" autoComplete="new-password" style={{ display: "none" }} />

      <input
        className={`wrap-validate_input1 ${continueLoginMode ? 'gray-out' : ''}`}
        name="real_user" // ✅ Change name to prevent autofill
        autoComplete="off" // ✅ Still needed
        placeholder="USERNAME"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
      />
      <input
        className={`wrap-validate_input1 margin-login ${continueLoginMode ? 'gray-out' : ''}`}
        placeholder="PASSWORD"
        value={password}
        type="password"
        autoComplete="new-password" // ✅ Prevent saved passwords
        name="real_pass" // ✅ Change name to prevent autofill
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      {continueLoginMode &&
      (<select
        className="betting-form__input"
        name="bettingShop"
        value={bettingShop}
        onChange={handleBetShopChange}
      >
        <option value="" disabled>
          Select Betting Shop
        </option>
        {bettingShopsDD.map((shop) => (
          <option key={shop._id} value={shop._id}>
            {shop.name}
          </option>
        ))}
      </select>)}

      <button className={`login-btn-yellow ${(continueLoginMode && !bettingShop) ? 'gray-out' : ''}`} type="submit">
        {continueLoginMode ? 'CONTINUE' : 'LOGIN'}
      </button>
    </form>
  );
};

export default LoginPage;
